import {
  enum as zodEnum,
  object,
  type output,
  string,
} from 'zod';
import { NotificationLocationCodes, NotificationTypeCode, NotificationTypeCodes } from '../notification';

const validNotificationTypeCodes = NotificationTypeCodes.filter(
  (typeCode): typeCode is Exclude<NotificationTypeCode, 'success'> => typeCode !== 'success'
);

export const notificationRequestSchema = object({
  message: string().min(1, 'Enter a message.'),
  typeCode: zodEnum(validNotificationTypeCodes, {
    error: (issue) => issue.input ? `Select one of these notification types: ${validNotificationTypeCodes.join(', ')}.` : 'Select a notification type.',
  }),
  locationCode: zodEnum(NotificationLocationCodes, {
    error: (issue) => issue.input ? `Select one of these notification locations: ${NotificationLocationCodes.join(', ')}.` : 'Select a notification location.',
  }),
});

export type NotificationRequest = output<typeof notificationRequestSchema>;
